export enum AreasStyle {
  Cards = 'cards',
  Dropdown = 'dropdown',
}

